const coverage = {
	employee_only: "Employee Only",
	employee_and_family: "Employee & Family"
};

export const cancerPlanDetails = {
	coverage: {
		employee_only: "Employee Only",
		employee_and_family: "Employee & Family"
	},
	coverage_level: {
		high_plan: "High Plan",
		low_plan: "Low Plan"
	}
};

export const BBI_PLAN_NAMES = {
	health_plan: "Health Plan",
	clinic_card: "Clinic Card",
	group_short_term_disability: "Group Short Term Disability",
	group_long_term_disability_class1: "Group Long Term Disability(Class 1)",
	group_long_term_disability_class2: "Group Long Term Disability(Class 2)",
	helping_our_own: "Helping Our Own",
	group_life_insurance: "Group Life Insurance",
	christmas_club_election_form: "Christmas Club Election",
	KSOP: "KSOP"
};

const planName = {
	kemper: {
		cancer: {
			standard_cancer: "Cancer",
			rider_cancer_intensive_care_unit: "Intensive Care Unit"
		},
		hospital: {
			standard_hospital: "Hospital Indemnity"
		},
		criticalIllness: {
			standard_critical_illness: "Critical Illness"
		},
		accident: {
			standard_accident: "Accident"
		},
		wholeLife: {
			standard_whole_life: "Whole life",
			ride_whole_life_chronic_illness: "Chronic Illness",
			ride_whole_life_child_term: "Child Term"
		}
	},
	five_star: {
		family_protection: {
			standard_family_protection: "Family Protection"
		}
	},
	doc_rx: {
		doc_rx: {
			standard_doc_rx: "Doc and Rx"
		}
	},
	beam: {
		vision: {
			standard_vision: "Vision"
		}
	},
	max_care: {
		dental: {
			standard_dental: "Dental"
		}
	},
	beazely: {
		group_life_indemnity: {
			standard_group_life_indemnity: "Group Limited Indemnity",
			rider_group_life_indemnity: "Clinic Card"
		}
	}
};

export const VEB_PLAN_NAMES = {
	cancer: "Cancer",
	accident: "Accident",
	whole_life: "Whole life",
	short_term_disability: "Short Term Disability",
	critical_illness: "Critical Illness",
	hospital_indemnity: "Hospital Indemnity",
	group_life_indemnity: "Group Limited Indemnity",
	family_protection: "Family Protection",
	doc_and_rx: "Doc and Rx",
	vision: "Vision",
	dental: "Dental"
};

export const VEB_PLAN_ARRAY = [
	"Cancer",
	"Accident",
	"Whole life",
	"Short Term Disability",
	"Critical Illness",
	"Hospital Indemnity",
	"Group Life Indemnity",
	"Family Protection",
	"Doc and Rx",
	"Vision",
	"Dental"
];

export const CorePlansName = [
	"Health Plan",
	"Clinic Card",
	"Group Short Term Disability",
	"Group Long Term Disability(Class 1)",
	"Group Long Term Disability(Class 2)",
	"Helping Our Own",
	"KSOP",
	"Christmas Club Election",
	"Group Life Insurance"
];

export const CorePanhandlePlansName = ["Health Plan", "Dental Plan", "Vision Plan", "Group Life Insurance", "KSOP"];

export const PLAN_NAME = planName;
export const VEB_PLAN_NAME = planName;
export const COVERAGE = coverage;
export const CANCER_PLAN_DETAILS = cancerPlanDetails;
